import { Mapper, PathUtils, ReadOnly } from 'module/Common';

export type Localized<T> = ReadOnly<Localized.Shape<T>>;

export namespace Localized {
  export type Shape<T> = { [K in PathUtils.Lang]: T };

  export const create = <T>(fr: T, en: T): Localized<T> => ({ fr, en });

  export const mapper = Mapper.mapSchema(
    {
      fr: Mapper.str,
      en: Mapper.str,
    },
    ({ fr, en }) => create(fr, en)
  );

  export function mapperWithDefault(defaultFr: string, defaultEn: string) {
    return Mapper.map(
      Mapper.nullable(
        Mapper.schema({
          fr: Mapper.nullable(Mapper.str),
          en: Mapper.nullable(Mapper.str),
        })
      ),
      val => {
        if (val === null) {
          return create(defaultFr, defaultEn);
        }
        return create(val.fr === null ? defaultFr : val.fr, val.en === null ? defaultEn : val.en);
      }
    );
  }

  export const transform = <T, U = T>(model: Localized<T>, transformFunc: (val: T) => U): Localized<U> => {
    return {
      fr: transformFunc(model.fr),
      en: transformFunc(model.en),
    };
  };

  // Mapper.mapSchema(
  //   {
  //     fr: Mapper.str,
  //     en: Mapper.str,
  //   },
  //   ({ fr, en }) => Localized.create(fr, en)
  // );

  export const istant = <T>(lang: PathUtils.Lang, fr: T, en: T): T => (lang === 'fr' ? fr : en);

  export const get = <T>(model: Localized<T>, lang: PathUtils.Lang): T => {
    return model[lang];
  };
}



// WEBPACK FOOTER //
// ./src/module/Model/Localized/index.ts